import { Mail, MapPin, Phone } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", href: "#home" },
    { name: "Shop", href: "#shop" },
    { name: "About", href: "#about" },
    { name: "Contact", href: "#contact" },
  ];

  const supportLinks = [
    { name: "Shipping Info", href: "#" },
    { name: "Returns", href: "#" },
    { name: "FAQ", href: "#" },
    { name: "Privacy Policy", href: "#" },
  ];

  return (
    <footer
      className="bg-brand-deepGreen text-brand-softBeige"
      data-testid="footer"
    >
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#home" className="inline-block mb-6" data-testid="footer-logo">
              <img 
                src="/images/logo.png" 
                alt="Pure Intentional - Tropical Hair Care" 
                className="h-32 md:h-40 w-auto object-contain"
              />
            </a>
            <p className="text-brand-softBeige/70 font-body font-light text-sm leading-relaxed">
              Premium tropical hair care crafted with intention. Nourishing your
              hair and scalp with the best of nature.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-light text-white mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-brand-softBeige/70 font-body text-sm hover:text-brand-warmGold transition-colors duration-300"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading text-lg font-light text-white mb-6">
              Support
            </h4>
            <ul className="space-y-3">
              {supportLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-brand-softBeige/70 font-body text-sm hover:text-brand-warmGold transition-colors duration-300"
                    data-testid={`footer-support-${link.name.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-light text-white mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-brand-warmGold" strokeWidth={1.5} />
                <a
                  href="mailto:hello@pureintentional.com"
                  className="text-brand-softBeige/70 font-body text-sm hover:text-brand-warmGold transition-colors duration-300"
                  data-testid="footer-email"
                >
                  hello@pureintentional.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-brand-warmGold" strokeWidth={1.5} />
                <a
                  href="tel:+12032439151"
                  className="text-brand-softBeige/70 font-body text-sm hover:text-brand-warmGold transition-colors duration-300"
                >
                  (203) 243-9151
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-brand-warmGold" strokeWidth={1.5} />
                <span className="text-brand-softBeige/70 font-body text-sm">
                  United States
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-brand-softBeige/50 font-body text-xs">
              © {currentYear} Pure Intentional. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-brand-softBeige/50 font-body text-xs hover:text-brand-warmGold transition-colors"
                data-testid="footer-terms"
              >
                Terms of Service
              </a>
              <a
                href="#"
                className="text-brand-softBeige/50 font-body text-xs hover:text-brand-warmGold transition-colors"
                data-testid="footer-privacy"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
